/* eslint-disable */
import { Observable, Observer } from 'rxjs';
import { Order, OrderType } from '../util/services';
import { MemStorage } from '../util/mem-storage';
import { Injectable } from '@angular/core';
import { OptionItem, UiConstants } from '../../util/core-utils';
import { Role } from './role.service';
import { DisabledItem } from '../../util/search-utils';
import { LoggedInUserStorage } from '../util/storages';

/* eslint-enable */

@Injectable()
export class RoleSearchService {

  constructor() {
  }

  getSearchData(request: RoleSearch.SearchDataGetRequest): Observable<RoleSearch.SearchDataResult> {
    const storage = this.createStorage();
    return Observable.create((observer: Observer<RoleSearch.SearchDataResult>) => {
      try {
        observer.next(storage.read(request));
      } catch (e) {
        observer.error(e);
      }
      observer.complete();
      return function () {
      };
    });
  }

  setSearchData(request: RoleSearch.SearchDataSetRequest): Observable<RoleSearch.SearchDataResult> {
    const storage = this.createStorage();
    return Observable.create((observer: Observer<RoleSearch.SearchDataResult>) => {
      try {
        observer.next(storage.save(request));
      } catch (e) {
        observer.error(e);
      }
      observer.complete();
      return function () {
      };
    });
  }

  resetSearchData(request: RoleSearch.SearchDataGetRequest): Observable<RoleSearch.SearchDataResult> {
    const storage = this.createStorage();
    return Observable.create((observer: Observer<RoleSearch.SearchDataResult>) => {
      try {
        observer.next(storage.reset(request));
      } catch (e) {
        observer.error(e);
      }
      observer.complete();
      return function () {
      };
    });
  }

  private createStorage(): RoleSearch.Storage {
    return new RoleSearch.Storage();
  }

}

export namespace RoleSearch {

  export interface SearchDataGetRequest {
  }

  export interface SearchDataSetRequest {
    searchData: SearchData;
  }

  export interface SearchDataResult {
    searchData: SearchData;
  }

  export interface SearchData {
    itemsPerPage: number;
    pageNumber: number;
    order: Order<Role.OrderField>;
    id: string;
    name: string;
    disabled?: DisabledItem;
  }

  interface StoredSearchRawDataBase {
    version: number;
  }

  interface StoredSearchRawData extends StoredSearchRawDataBase {
    itemsPerPage: number;
    pageNumber: number;
    order: Order<Role.OrderField>;
    id: string;
    name: string;
    disabled?: DisabledItem;
  }

  export class Storage {

    /**
     * Increment this version if you change the SearchData interface.
     */
    private static readonly VERSION: number = 2;

    private static readonly DEFAULT_SEARCH_DATA: SearchData = {
      itemsPerPage: UiConstants.pageNumbers[0],
      pageNumber: 1,
      order: {
        field: Role.OrderField.ID,
        type: OrderType.DESC
      },
      id: '',
      name: '',
      disabled: DisabledItem.active()
    };

    constructor() {
    }

    public read(request: SearchDataGetRequest): SearchDataResult {
      const key = this.generateKey();
      let rawBase: StoredSearchRawDataBase;
      try {
        const json = MemStorage.getItem(key);
        if (!json) {
          return this.createDefaultResult();
        }
        rawBase = JSON.parse(json);
      } catch (error) {
        return this.createDefaultResult();
      }
      if (Storage.VERSION === rawBase.version) {
        const raw: StoredSearchRawData = <StoredSearchRawData>rawBase;
        return this.fromRaw(raw);
      }
      return this.createDefaultResult();
    }

    public reset(request: SearchDataGetRequest): SearchDataResult {
      return this.save({
        searchData: Storage.DEFAULT_SEARCH_DATA,
      });
    }

    public save(request: SearchDataSetRequest): SearchDataResult {
      const key = this.generateKey();
      const raw = this.toRaw(request.searchData);
      const json = JSON.stringify(raw);
      MemStorage.setItem(key, json);
      return this.read(request);
    }

    private generateKey(): string {
      return 'UserId(' + LoggedInUserStorage.getInstance().getUserId() + ')-Search-Role';
    }

    private createDefaultResult(): SearchDataResult {
      return {
        searchData: Storage.DEFAULT_SEARCH_DATA,
      };
    }

    private fromRaw(data: StoredSearchRawData): SearchDataResult {
      return {
        searchData: {
          itemsPerPage: data.itemsPerPage,
          pageNumber: data.pageNumber,
          order: data.order,
          id: data.id,
          name: data.name,
          disabled: data.disabled
        }
      };
    }

    private toRaw(data: SearchData): StoredSearchRawData {
      return {
        version: Storage.VERSION,
        itemsPerPage: data.itemsPerPage,
        pageNumber: data.pageNumber,
        order: data.order,
        id: data.id,
        name: data.name,
        disabled: data.disabled
      }
        ;
    }

  }

}

export class RoleSearchModel {
  id: string = '';
  name: string = '';
  disabled?: DisabledItem;

  public isEmpty(): boolean {
    return this.id.length === 0
      && this.name.length === 0
      && OptionItem.idOrUndefined(this.disabled) === undefined
      ;
  }
}

export type RoleDisabled =
  'ALL' |
  'ACTIVE' |
  'INACTIVE';

export class RoleDisabledItem extends OptionItem<RoleDisabled> {
}

export class RoleDisabledItems {
  public static readonly values: RoleDisabled[] = ['ALL', 'ACTIVE', 'INACTIVE'];
}
